import React from 'react';
import './NotFound.css';

const NotFound: React.FC = () => {
  return (
    <div className="background-gradient">
      <section className="section">
        <div className="container notfound">
          <div className="notfound-card card">
            <p className="notfound-code">404</p>
            <h1 className="notfound-title">Страница не найдена</h1>
            <p className="notfound-text">
              Кажется, этой страницы не существует. Проверьте адрес или вернитесь на главную.
            </p>
            <a className="cta-button" href="/">
              На главную
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
